module.exports = __webpack_public_path__ + "img/crowdfunding.8c5fa80e.jpeg";